module.exports = __webpack_public_path__ + "static/media/productTypeCC.7945a9d4.svg";